export default "__VITE_ASSET__6543cfdb__"